import NotificationActions from '../../../actions/NotificationActions';
import GuestActions from '../../../actions/GuestActions';
import PosActions from '../../../actions/PosActions';
import PopupActions from '../../../actions/PopupActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';
import PosStore from '../../../stores/PosStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as GuestEndPoints } from '../../../constants/GuestConstants';

import SignatureCanvas from 'react-signature-canvas';

import Price from '../../form/Price.react';
import Transaction from './Transaction.react';

// import Stucky from 'stucky';
import StickyHeader from '../../form/StickyHeader.react';
import PageHeader from '../../form/layout/PageHeader.react';

class ViewPolicy extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading             : false,

            signed              : false,
            signature           : null,
            agreementHtml       : null,

            pointCount          : 0,
        };

        this.loadPolicyAgreement = this.loadPolicyAgreement.bind(this);
        this.save = this.save.bind(this);
        this.onSignatureEnd = this.onSignatureEnd.bind(this);
    }

    componentDidMount() {
        this.loadPolicyAgreement();
    }

    loadPolicyAgreement() {
        var self = this;

        AjaxPromises.POST(GuestEndPoints.GET_POLICY_AGREEMENT, UserStore.getApiData({
            acctId : this.props.guest.Guest_id
        })).then(res => {
            if (res.Result) {
                this.setState({
                    signed: res.Data.SignatureBase64 ? true : false,
                    signature: res.Data.SignatureBase64,
                    agreementHtml : res.Data.AgreementHTML
                });
            } else
                NotificationActions.error('Could not load policy agreement')
        });
    }

    onSignatureEnd() {
        this.setState({
            pointCount : this.refs.Signature.toData().reduce((c,a) => c + a.length, 0)
        });
    }

    save() {
        var self = this;

        if (this.state.loading || !this.isValid())
            return;

        this.setState({ loading : true }, () => {
            AjaxPromises.POST(GuestEndPoints.SET_POLICY_AGREEMENT, UserStore.getApiData({
                AcctId : this.props.guest.Guest_id,
                SignatureBase64 : this.refs.Signature.toDataURL('image/png').split(',')[1],
                WasAccepted: true,
            })).then(res => {

                if (res.Result) {
                    self.setState({
                        signed: true,
                        loading : false
                    });

                    self.loadPolicyAgreement();

                    NotificationActions.success('Policy agreement signed successfully.')
                } else {
                    self.setState({
                        loading : false,
                    });

                    NotificationActions.error('Policy agreement could not be signed.')
                }
            });
        })
    }

    isValid() {
        return this.state.pointCount > 30 && !this.props.guest.IsAnonymous;
    }

    render() {
        var self    = this;
        var guest   = this.props.guest;
        var page    = this.props.page;
        var isValid = (this.state.pointCount > 30);

        if (page !== 'policy')
            return null;

        return ([
            <div className={'view-history '+this.props.className}>

                <PageHeader title='Patient Policy Agreement' noMargin />

                    { this.state.agreementHtml &&
                        <div style={{ height: '55%', overflowY: 'scroll' }}
                            dangerouslySetInnerHTML={{ __html: this.state.agreementHtml }} />
                    }

                <div className='view-policy'>
                { this.state.signed && this.state.signature &&
                    <img
                        src={'data:image/png;base64, '+this.state.signature}
                        className='view-policy__canvas' />
                }

                { !this.state.signed &&[
                        <SignatureCanvas
                            penColor='black'
                            ref='Signature'
                            canvasProps={{className: 'view-policy__canvas'}}
                            onEnd={this.onSignatureEnd} />,
                        <br />,
                        <div className={'view-policy__buttons'}>
                            <div
                                class={'btn-green ' + (!this.isValid() ? 'btn-green__disabled' : '')}
                                style={{'marginRight':20}}
                                onClick={!guest.IsAnonymous ? this.save : null}>
                                SAVE
                            </div>
                            <div
                                class="btn-green"
                                onClick={() => {
                                    this.refs.Signature.clear();
                                    this.setState({ pointCount : 0 });
                                }}>
                                CLEAR
                            </div>
                        </div>
                ]}
                </div>
            </div>
        ]);
    }
}

export default ViewPolicy;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ViewPolicy.react.jsx